(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sn-bundle-picker"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    let bundleItems = [];
    const maxItems = 3;
    const currencySymbol = window.bundleCurrencySymbol || '$';
    let swiperMain, swiperThumb;

    const modal = document.getElementById('sn-product-modal');
    const modalData = document.getElementById('modal-data');
    const modalLoader = document.getElementById('modal-loader');

    function refreshUI() {
      document.querySelectorAll('.sn-quantity-wrapper').forEach((wrapper) => {
        const vid = wrapper.dataset.variantId;
        const count = bundleItems.filter((i) => i.id === vid).length;
        const addBtn = wrapper.querySelector('.js-add-btn');
        const qtyControls = wrapper.querySelector('.sn-qty-controls');
        const qtyNum = wrapper.querySelector('.js-qty-num');
        if (addBtn) addBtn.style.display = count > 0 ? 'none' : 'block';
        if (qtyControls) qtyControls.style.display = count > 0 ? 'flex' : 'none';
        if (qtyNum) qtyNum.textContent = count;
      });

      const slots = document.querySelectorAll('.blank-card');
      const icons = document.querySelectorAll('.progress-icon');
      bundleItems.forEach((item, idx) => {
        if (slots[idx]) {
          slots[idx].innerHTML = `<div class="bundle-item-active" style="position:relative; width:100%; height:100%;">
            <img src="${item.img}" style="width:100%; height:100%; object-fit:cover; border-radius:8px;">
            <button class="remove-item" data-index="${idx}" style="position:absolute; top:-5px; right:-5px; background:red; color:white; border:none; border-radius:50%; width:20px; height:20px; cursor:pointer; z-index:10; font-size: 14px; line-height: 1;">&times;</button>
          </div>`;
        }
        if (icons[idx]) icons[idx].classList.add('is-active');
      });
      for (let i = bundleItems.length; i < maxItems; i++) {
        if (slots[i]) slots[i].innerHTML = '+';
        if (icons[i]) icons[i].classList.remove('is-active');
      }
      const progressBox = document.querySelector('.progress-box');
      if (progressBox) progressBox.style.setProperty('--progress-width', `${(bundleItems.length / maxItems) * 65}%`);

      let total = 0;
      let cheapestIdx = -1;
      if (bundleItems.length === maxItems) {
        let low = Infinity;
        bundleItems.forEach((it, i) => {
          if (it.price < low) {
            low = it.price;
            cheapestIdx = i;
          }
        });
      }
      document.querySelectorAll('.js-slot-price').forEach((el, i) => {
        const it = bundleItems[i];
        if (it) {
          if (i === cheapestIdx)
            el.innerHTML = `<span style="text-decoration:line-through; opacity:0.6;">${currencySymbol}${(
              it.price / 100
            ).toFixed(2)}</span> <b style="color:#28a745">FREE</b>`;
          else {
            el.textContent = currencySymbol + (it.price / 100).toFixed(2);
            total += it.price;
          }
        } else el.textContent = currencySymbol + '0.00';
      });
      const totalDisplay = document.querySelector('.total-price');
      if (totalDisplay) totalDisplay.textContent = currencySymbol + (total / 100).toFixed(2);
      document.querySelectorAll('.remove-item').forEach((btn) => {
        btn.onclick = (e) => {
          e.stopPropagation();
          bundleItems.splice(parseInt(btn.dataset.index), 1);
          refreshUI();
        };
      });
    }

    const openModal = () => {
      modal.style.display = 'flex';
      document.body.style.overflow = 'hidden';
      const header = document.getElementById('shopify-section-header');
      if (header) header.style.position = 'static';
    };
    const closeModal = () => {
      modal.style.display = 'none';
      document.body.style.overflow = '';
      const header = document.getElementById('shopify-section-header');
      if (header) header.style.position = '';
    };

    document.querySelectorAll('.js-quick-view').forEach((anchor) => {
      anchor.addEventListener('click', function (e) {
        e.preventDefault();
        openModal();
        modalData.style.display = 'none';
        modalLoader.style.display = 'block';

        fetch(`/products/${this.dataset.handle}.js`)
          .then((res) => res.json())
          .then((product) => {
            const mainWrap = document.getElementById('modal-main-slides');
            const thumbWrap = document.getElementById('modal-thumb-slides');
            let mainHtml = '';
            let thumbHtml = '';
            product.images.forEach((img) => {
              mainHtml += `<div class="swiper-slide"><img src="${img}" alt="${product.title}"></div>`;
              thumbHtml += `<div class="swiper-slide"><img src="${img}" alt="${product.title}"></div>`;
            });
            mainWrap.innerHTML = mainHtml;
            thumbWrap.innerHTML = thumbHtml;

            document.getElementById('modal-product-title').textContent = product.title;
            let modalPriceHtml = currencySymbol + (product.price / 100).toFixed(2);
            if (product.compare_at_price > product.price) {
              modalPriceHtml += ` <span style="text-decoration:line-through; color:rgba(0,0,0,0.5); font-weight:normal; margin-left:8px;">${currencySymbol}${(
                product.compare_at_price / 100
              ).toFixed(2)}</span>`;
            }
            const priceContainer = document.getElementById('modal-product-price');
            priceContainer.innerHTML = modalPriceHtml;
            priceContainer.dataset.price = product.price;
            document.getElementById('modal-product-desc').innerHTML = product.description;
            document.getElementById(
              'modal-reviews-stars'
            ).innerHTML = `<span class="shopify-product-reviews-badge" data-id="${this.dataset.pid}"></span>`;

            const varCont = document.getElementById('modal-variant-container');
            varCont.innerHTML = '';
            if (product.variants.length > 1) {
              let sel = document.createElement('select');
              sel.className = 'sn-variant-select modal-variant-swapper';
              product.variants.forEach((v) => {
                let opt = document.createElement('option');
                opt.value = v.id;
                opt.text = `${v.title} - ${v.available ? currencySymbol + (v.price / 100).toFixed(2) : 'Sold Out'}`;
                opt.dataset.price = v.price;
                opt.dataset.comparePrice = v.compare_at_price || 0;
                opt.dataset.imgIdx = v.featured_image ? product.images.indexOf(v.featured_image.src) : 0;
                sel.appendChild(opt);
              });
              varCont.appendChild(sel);
            }
            document.getElementById('modal-qty-wrapper').dataset.variantId = product.variants[0].id;

            modalLoader.style.display = 'none';
            modalData.style.display = 'flex';

            if (swiperMain) swiperMain.destroy();
            if (swiperThumb) swiperThumb.destroy();

            swiperThumb = new Swiper('.swiper-thumb', {
              spaceBetween: 8,
              slidesPerView: 5,
              freeMode: true,
              watchSlidesProgress: true,
              observer: true,
              observeParents: true,
              slideToClickedSlide: true,
            });

            swiperMain = new Swiper('.swiper-main', {
              spaceBetween: 10,
              slidesPerView: 1.2,
              centeredSlides: true,
              observer: true,
              observeParents: true,
              navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              },
              thumbs: { swiper: swiperThumb },
            });

            refreshUI();
          });
      });
    });

    document.querySelector('.close-modal').onclick = closeModal;
    window.onclick = (e) => {
      if (e.target == modal) closeModal();
    };

    document.body.addEventListener('change', (e) => {
      if (e.target.classList.contains('modal-variant-swapper')) {
        const opt = e.target.options[e.target.selectedIndex];
        document.getElementById('modal-qty-wrapper').dataset.variantId = e.target.value;
        const price = parseFloat(opt.dataset.price);
        const comparePrice = parseFloat(opt.dataset.comparePrice);
        let modalPriceHtml = currencySymbol + (price / 100).toFixed(2);
        if (comparePrice > price) {
          modalPriceHtml += ` <span style="text-decoration:line-through; color:rgba(0,0,0,0.5); font-weight:normal; margin-left:8px;">${currencySymbol}${(
            comparePrice / 100
          ).toFixed(2)}</span>`;
        }
        const priceContainer = document.getElementById('modal-product-price');
        priceContainer.innerHTML = modalPriceHtml;
        priceContainer.dataset.price = price;
        swiperMain.slideTo(parseInt(opt.dataset.imgIdx));
        refreshUI();
      }
      if (e.target.classList.contains('card-variant-swapper')) {
        const opt = e.target.options[e.target.selectedIndex];
        const det = e.target.closest('.product-details');
        det.querySelector('.sn-quantity-wrapper').dataset.variantId = e.target.value;
        const priceSpan = det.querySelector('.regular-price');
        priceSpan.dataset.price = opt.dataset.price;
        priceSpan.textContent = currencySymbol + (opt.dataset.price / 100).toFixed(2);
        refreshUI();
      }
    });

    document.body.addEventListener('click', (e) => {
      const wrap = e.target.closest('.sn-quantity-wrapper');
      if (!wrap) return;
      const vid = wrap.dataset.variantId;
      let price, img;
      if (wrap.id === 'modal-qty-wrapper') {
        price = parseInt(document.getElementById('modal-product-price').dataset.price);
        const activeSlide = document.querySelector('.swiper-main .swiper-slide-active img');
        img = activeSlide ? activeSlide.src : '';
      } else {
        const det = wrap.closest('.product-details');
        const priceSpan = det.querySelector('.regular-price');
        price = parseInt(priceSpan.dataset.price);
        img = wrap.closest('.sn-product-wrap').querySelector('.sn-img').src;
      }
      if (e.target.classList.contains('js-add-btn') || e.target.classList.contains('js-qty-plus')) {
        if (bundleItems.length < maxItems) bundleItems.push({ id: vid, price: price, img: img });
        else alert('Bundle Full!');
      }
      if (e.target.classList.contains('js-qty-minus')) {
        const i = bundleItems.map((it) => it.id).lastIndexOf(vid);
        if (i > -1) bundleItems.splice(i, 1);
      }
      refreshUI();
    });

    document.querySelector('.sn-btn').onclick = () => {
      if (!bundleItems.length) return alert('Add items to your bundle!');
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: bundleItems.map((it) => ({ id: it.id, quantity: 1 })) }),
      }).then((res) => (res.ok ? (window.location.href = '/cart') : alert('Checkout Error.')));
    };
    refreshUI();
  });

  } catch(e) { console.error(e); }
})();
})();
